// extracted by mini-css-extract-plugin
export var bodySections = "_4w-8";
export var gray = "_4w-7";
export var green = "_4w-4";
export var iconContainer = "_4w-9";
export var iconWidgetContainer = "_4w-1";
export var phoneIcon = "_4w-2";
export var red = "_4w-5";
export var statusDot = "_4w-3";
export var widgetContainer = "_4w-0";
export var yellow = "_4w-6";